import { Field, Formik, Form, ErrorMessage } from "formik";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import successToast from "../../components/toasts/successToast";
import logo from "../../assets/images/acumenVelocityLogo.svg";
import { Image, Spinner } from "react-bootstrap";
import { emailLoginAction } from "../../redux/actions/authAction";
import { useDispatch } from "react-redux";
import errorToast from "../../components/toasts/errorToast";
import { useAuth } from "../../context/AuthContext";

const EmailLogin = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { fetchMe } = useAuth();

    const initialValues = {
        email: "",
        password: "",
    };

    const [loading, setLoading] = useState(false);
    const onSuccess = async (data) => {
        if (data.data.data.requires_2fa) {
            sessionStorage.setItem('2fa_session_token', data.data.data.session_token);
            setLoading(false);
            navigate('/verify-2fa');
            return;
        }
        await fetchMe();
        setLoading(false);
        localStorage.setItem("active_tab", 'Overview');
        successToast(data.data.message);
        navigate('/over-view');
    };
    const onError = (data) => {
        setLoading(false);
        errorToast(data.data.message);
    };

    const validationSchema = Yup.object().shape({
        email: Yup.string().required("Required").email("Invaild Email"),
        password: Yup.string().required("Required"),
    });

    const onSubmit = (values) => {
        const dispatchingValues = {
            email: values.email,
            password: values.password,
        };
        dispatch(emailLoginAction(dispatchingValues, onSuccess, onError));
        setLoading(true);
    };
    return (
        <div
            className="min-vh-100 d-flex flex-column"
            style={{ backgroundColor: "#E9EEF7" }}
        >
            <div
                className="d-flex align-items-center cursor_pointer p-2"
                style={{ height: "8vh" }}
                onClick={() => navigate("/")}
            >
                <Image alt="logo" src={logo} height={40} className="mx-2" />
                <p className="name fs_18 fw_600 m-0 ">Acumen Translation Hub</p>
            </div>
            <div className="flex-grow-1 d-flex flex-column justify-content-center align-items-center fn_Roboto">
                <div className="bg-light border-opacity-10  border d-flex flex-column justify-content-center align-items-center p-4 rounded-2  gap-2 col-12 col-md-8 col-lg-4">
                    <h4 className="fw_500 fn_Roboto">Email Login</h4>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                    >
                        {({ values, setFieldValue, isValid, dirty }) => (
                            <Form className="h-100 justify-content-between w-100 px-5">
                                <div>
                                    <div className="text-start gap-3 mb-2 text-nowrap ">
                                        <label htmlFor="email" className="py-2">
                                            Email
                                        </label>
                                        <div className="d-flex position-relative">
                                            <Field
                                                name="email"
                                                className="input-field w-100"
                                                id="email"
                                                placeHolder="Enter Email"
                                            />
                                        </div>
                                        <ErrorMessage
                                            name="email"
                                            component="div"
                                            className="text-danger mt-1 fs_12"
                                        />
                                    </div>
                                    <div className="text-start gap-3 mb-2 text-nowrap">
                                        <label htmlFor="password" className="py-1">
                                            Password
                                        </label>
                                        <div className="d-flex position-relative">
                                            <Field
                                                type={"password"}
                                                name="password"
                                                className="input-field w-100"
                                                id="password"
                                                placeHolder="Enter Password"
                                            />
                                        </div>
                                        <ErrorMessage
                                            name="password"
                                            component="div"
                                            className="text-danger mt-1 fs_12"
                                        />
                                    </div>
                                    <div
                                        className="mt-2 d-flex justify-content-end cursor_pointer"
                                        onClick={() => navigate("/forgot-password")}
                                    >
                                        <span className="text-primary fw_400 fs_15">Forgot Password?</span>
                                    </div>
                                </div>
                                {loading && (
                                    <div className="d-flex align-items-center text-center">
                                        <Spinner size="sm" className="text-primary" />{" "}
                                        <span className="ms-2">Logging in...</span>
                                    </div>
                                )}
                                <div className="d-flex justify-content-between mt-4">
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={loading}
                                    >
                                        Login
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        disabled={loading}
                                        onClick={() => navigate("/")}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </div >
    );
};

export default EmailLogin;
